import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import EnforcementTabletDetailViewModel from "viewModels/enforcement/enforcementTablets/enforcementTabletDetailViewModel";
import EditableDetailView from "../../common/editableDetailView";
import EnforcementTabletForm from "./enforcementTabletForm";

const EnforcementTabletDetailView: ViewComponent<EnforcementTabletDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<EnforcementTabletForm vm={vm} />} />;
});

registerView(EnforcementTabletDetailView, EnforcementTabletDetailViewModel);
